import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Logo } from './Logo';
import { Menu, X, Phone, ChevronDown, ChevronUp } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPoliciesOpen, setIsPoliciesOpen] = useState(false);
  const location = useLocation();
  const policiesRef = useRef<HTMLDivElement>(null);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const togglePolicies = () => {
    setIsPoliciesOpen(!isPoliciesOpen);
  };
  // Close policies dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (policiesRef.current && !policiesRef.current.contains(event.target as Node)) {
        setIsPoliciesOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  // Close policies dropdown when route changes
  useEffect(() => {
    setIsPoliciesOpen(false);
  }, [location.pathname]);
  const mainNavLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Service Coverage',
    path: '/service-coverage'
  }, {
    name: 'About Us',
    path: '/about-us'
  }, {
    name: 'Contact Us',
    path: '/contact-us'
  }, {
    name: 'FAQs',
    path: '/faqs'
  }];
  const policyLinks = [{
    name: 'Cancellation Policy',
    path: '/cancellation-policy'
  }, {
    name: 'Refund Policy',
    path: '/refund-policy'
  }, {
    name: 'Privacy Policy',
    path: '/privacy-policy'
  }, {
    name: 'Terms & Conditions',
    path: '/terms-and-conditions'
  }];
  return <header className="bg-white shadow-sm w-full" data-id="element-110">
      <div className="container mx-auto px-4 py-4" data-id="element-111">
        <div className="flex justify-between items-center" data-id="element-112">
          <Logo data-id="element-113" />
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8" data-id="element-114">
            {mainNavLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium hover:text-secondary transition-colors ${location.pathname === link.path ? 'text-secondary' : 'text-dark'}`} data-id="element-115">
                {link.name}
              </Link>)}
            {/* Policies Dropdown - Desktop */}
            <div className="relative" ref={policiesRef} data-id="element-116">
              <button onClick={togglePolicies} className={`flex items-center text-sm font-medium hover:text-secondary transition-colors ${policyLinks.some(link => location.pathname === link.path) ? 'text-secondary' : 'text-dark'}`} data-id="element-117">
                Policies & Terms
                {isPoliciesOpen ? <ChevronUp size={16} className="ml-1" data-id="element-118" /> : <ChevronDown size={16} className="ml-1" data-id="element-119" />}
              </button>
              {isPoliciesOpen && <div className="absolute z-10 mt-2 w-56 bg-white rounded-md shadow-lg py-1" data-id="element-120">
                  {policyLinks.map(link => <Link key={link.path} to={link.path} className={`block px-4 py-2 text-sm hover:bg-gray-100 ${location.pathname === link.path ? 'text-secondary font-medium' : 'text-dark'}`} data-id="element-121">
                      {link.name}
                    </Link>)}
                </div>}
            </div>
          </nav>
          {/* Phone Number - Desktop */}
          <div className="hidden lg:flex items-center" data-id="element-122">
            <a href="tel:08000554969" className="flex items-center gap-2 bg-primary text-white px-4 py-2 rounded-md hover:bg-opacity-90 transition-all" data-id="element-123">
              <Phone size={18} data-id="element-124" />
              <span className="font-medium" data-id="element-125">0800 055 4969</span>
            </a>
          </div>
          {/* Mobile Menu Button */}
          <button onClick={toggleMenu} className="lg:hidden text-dark focus:outline-none" data-id="element-126">
            {isMenuOpen ? <X size={24} data-id="element-127" /> : <Menu size={24} data-id="element-128" />}
          </button>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <nav className="lg:hidden mt-4 pb-4" data-id="element-129">
            <div className="flex flex-col space-y-3" data-id="element-130">
              {mainNavLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium py-2 hover:text-secondary transition-colors ${location.pathname === link.path ? 'text-secondary' : 'text-dark'}`} onClick={() => setIsMenuOpen(false)} data-id="element-131">
                  {link.name}
                </Link>)}
              {/* Policies Dropdown - Mobile */}
              <div className="py-2" data-id="element-132">
                <button onClick={togglePolicies} className={`flex items-center w-full text-left text-sm font-medium hover:text-secondary transition-colors ${policyLinks.some(link => location.pathname === link.path) ? 'text-secondary' : 'text-dark'}`} data-id="element-133">
                  Policies & Terms
                  {isPoliciesOpen ? <ChevronUp size={16} className="ml-2" data-id="element-134" /> : <ChevronDown size={16} className="ml-2" data-id="element-135" />}
                </button>
                {isPoliciesOpen && <div className="mt-2 pl-4 space-y-2 border-l-2 border-gray-100" data-id="element-136">
                    {policyLinks.map(link => <Link key={link.path} to={link.path} className={`block py-1 text-sm hover:text-secondary ${location.pathname === link.path ? 'text-secondary' : 'text-dark'}`} onClick={() => setIsMenuOpen(false)} data-id="element-137">
                        {link.name}
                      </Link>)}
                  </div>}
              </div>
              <a href="tel:08000554969" className="flex items-center gap-2 text-primary mt-2" data-id="element-138">
                <Phone size={18} data-id="element-139" />
                <span className="font-medium" data-id="element-140">0800 055 4969</span>
              </a>
            </div>
          </nav>}
      </div>
    </header>;
};